import { makeAccess } from '../../../config/factory-controller'

interface FindUserInformationRequest {
  dpi: string
  agencyCode: string
  employeeNumber: string
}

interface FindUserInformationResponse {
  dpi: string
  employeeNumber: number
  agencyId: number
  isFirstAccess: boolean
  userInformationId: number
  // outros campos ignorados
}

interface CreateUserLoginRequest {
  dpi: string
  employeeNumber: number
  agencyId: number
  isFirstAccess: boolean
  userInformationId: number
  pin: string
}

export const userService = {
  async findUserInformation(
    payload: FindUserInformationRequest,
  ): Promise<FindUserInformationResponse> {
    const API_URL = import.meta.env.VITE_REACT_APP_API_URL?.replace(/\/+$/, '')
    const url = `${API_URL}/user/finduserinformation`

    const { key: applicationKey, token: applicationToken } = await makeAccess()
    const apiVersion = Number(import.meta.env.VITE_REACT_APP_API_VERSION)

    if (!applicationKey || !applicationToken) {
      throw new Error('Credenciales de aplicación faltantes (key/token).')
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-version': String(apiVersion),
        'x-application-key': applicationKey,
        'x-application-token': applicationToken,
      },
      body: JSON.stringify(payload),
    })

    if (!response.ok) {
      throw new Error(`Error al buscar usuario (${response.status})`)
    }

    const data = await response.json()
    // Assume estrutura { data: { dpi, employeeNumber, agencyId, isFirstAccess } }
    return {
      dpi: data?.data?.dpi,
      employeeNumber: data?.data?.employeeNumber,
      agencyId: data?.data?.agencyId,
      isFirstAccess: data?.data?.isFirstAccess,
      userInformationId: data?.data?.userInformationId,
    }
  },

  async createUserLogin(payload: CreateUserLoginRequest): Promise<void> {
    const API_URL = import.meta.env.VITE_REACT_APP_API_URL?.replace(/\/+$/, '')
    const url = `${API_URL}/auth/createuserlogin`

    const { key: applicationKey, token: applicationToken } = await makeAccess()
    const apiVersion = Number(import.meta.env.VITE_REACT_APP_API_VERSION)

    if (!applicationKey || !applicationToken) {
      throw new Error('Credenciales de aplicación faltantes (key/token).')
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-version': String(apiVersion),
        'x-application-key': applicationKey,
        'x-application-token': applicationToken,
      },
      body: JSON.stringify(payload),
    })

    if (!response.ok) {
      throw new Error(`Error al crear inicio de sesión (${response.status})`)
    }
  },
}
